/*
 * Mobile - PDP - Above The Fold V2  --  variant: Remove Menu + Font Reduction
 * Moonshot experiment id: 29839482   status in Moonshot on 2026-08-27: DEPLOYED   started: 2025-11-24
 * Audience: MOBILE   Target: pdp   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_pdp_m_above_fold_v2
 */
MGExp.run('pdp_m_above_fold_v2', { name: "Mobile - PDP - Above The Fold V2 / Remove Menu + Font Reduction", platform: 'mobile', target: 'pdp' }, function () {
  !(function () {
    let t = [],
      o = [];
    !(async function (i, e, n, a, p) {
      let r = {
        multi_target_selectors: t,
        page_identifier_selector: "section.prod-page",
        exclude_from_timeout: o,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(i, e, n, a, p, r);
    })(
      ["section.prod-page"],
      ".msai-navigation-removed",
      function (t, o) {
        const [i] = o;
        i.classList.add("msai-navigation-removed");
      },
      "#nav-container-mobile #mobile-secondary-nav{display:none !important}body.template-product{padding-top:110px !important}.prod-page .product-image-column.w-full{position:relative;top:-15px !important;padding-top:0}.imgs.flex{max-width:280px !important;margin:0 auto !important}.dot-indicators.flex{margin-bottom:13px !important}.product-description-column.w-full{padding-top:10px !important}h1.pdp-product-title{font-size:1.37rem;line-height:1.8rem}#price.money{font-size:1rem}.flex.items-center.space-y-1,.pdp-payment-options{margin-top:10px !important}",
    );
  })();
});
